import { render, staticRenderFns } from "./msg-list.vue?vue&type=template&id=4bdcb430&scoped=true&"
import script from "./msg-list.vue?vue&type=script&lang=js&"
export * from "./msg-list.vue?vue&type=script&lang=js&"
import style0 from "./msg-list.vue?vue&type=style&index=0&id=4bdcb430&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdcb430",
  null
  
)

export default component.exports